import { useEffect, useState } from 'react';
import { api, mainImage, imageUrl } from './api';
import { Skeleton, toast } from './feedback';

export default function TrashList({ onRestored }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);

  const load = async () => {
    setError('');
    try {
      setItems(await api.getTrash());
    } catch (e) {
      setError(`Không tải được thùng rác: ${e.message}`);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const run = async (id, action, successMessage) => {
    setError('');
    setBusyId(id);
    try {
      await action();
      toast(successMessage);
      await load();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusyId(null);
    }
  };

  const restore = (a) =>
    run(a.id, async () => {
      await api.restore(a.id);
      onRestored();
    }, 'Đã khôi phục tranh');

  // Chỉ tranh chưa từng xuất QR mới được xoá hẳn
  const removePermanently = (a) => {
    if (!window.confirm(`Xoá vĩnh viễn "${a.title}"?\n\nTranh chưa xuất QR nên xoá được, toàn bộ ảnh cũng bị xoá và không khôi phục được.`)) return;
    run(a.id, () => api.removePermanently(a.id), 'Đã xoá vĩnh viễn tranh');
  };

  return (
    <div>
      {error && <p className="error">{error}</p>}
      {items === null && !error && (
        <div className="trash-list">
          {[1, 2, 3].map((i) => (
            <div key={i} className="trash-item" aria-hidden="true">
              <Skeleton width={60} height={60} />
              <div className="trash-info">
                <Skeleton width="45%" height={15} />
                <Skeleton width="30%" height={12} />
              </div>
            </div>
          ))}
        </div>
      )}
      {items?.length === 0 && <p className="muted">Thùng rác trống.</p>}

      <div className="trash-list">
        {items?.map((a) => {
          const img = mainImage(a);
          return (
            <div key={a.id} className="trash-item">
              {img ? <img className="thumb" src={imageUrl(img.imageUrl, 120)} alt="" /> : <div className="thumb no-image">—</div>}
              <div className="trash-info">
                <strong>{a.title}</strong>
                <span>Mã: {a.code}</span>
                <span>Xoá lúc: {a.deletedAt}</span>
              </div>
              <div className="trash-actions">
                <button disabled={busyId === a.id} onClick={() => restore(a)}>
                  Khôi phục
                </button>
                {!a.qrToken && (
                  <button className="danger" disabled={busyId === a.id} onClick={() => removePermanently(a)}>
                    Xoá vĩnh viễn
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
